<template>
  <div>
    <div class="basic-loading-bounce-container">
      <LoadingBounce></LoadingBounce>
    </div>

    <b-modal
      id="basic-error-alert"
      class="basic-modal no-header-modal hide-cancel-btn"
      :hide-header="true"
      :ok-title="$t('common.confirm')"
    >
      <div v-html="$t('common.modal.basic_error_alert.message')"></div>
    </b-modal>

    <LicenceModal @ok="closeLicenceModal()" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import Mobile from '@/mixins/Mobile';

export default {
  name: 'cat-card-show-cover',

  mixins: [
    Mobile,
  ],

  computed: {
    ...mapGetters({
      cat: 'getCatCard',
      routeParams: 'getRouteParams',
      isCatCompleted: 'isCatCompleted',
      remainCatQuizResults: 'getRemainCatQuizResults',
    }),

    catId() {
      return this.routeParams.catId;
    },

    catQuizNextPage() {
      return Number(this.remainCatQuizResults + 1);
    },
  },

  methods: {
    ...mapActions({
      fetchCatCard: 'fetchCatCard',
    }),
  },

  beforeMount() {
    if (this.isClasstingAndroid) {
      this.callActionbar(true);
    }

    if (isEmpty(this.catId)) {
      return this.$root.$emit('bv::show::modal', 'basic-error-alert');
    }

    return this.fetchCatCard({ catId: this.catId })
      .then(() => {
        if (this.isCatCompleted) {
          return this.$router.replace({
            name: 'catCard.results',
            params: { catId: this.catId },
          });
        }

        return this.$router.replace({
          name: 'catPages.show',
          params: {
            catId: this.catId,
            page: this.catQuizNextPage,
          },
        });
      })
      .catch(() => this.$root.$emit('bv::show::modal', 'basic-error-alert'));
  },
};
</script>
